<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formProduto from '@/src/components/form-produto'

import Produto from '@/src/services/produto'
import NewProd from '@/src/services/newprod'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formProduto },
  data() {
    return {
      mostraForm: true,
      produtoEdit: {},
      produtos: [],
      allProdutos: [],
      activeTab: 'ativos',
      produtoFields: [
        {
          key: 'id_produto',
          label: 'ID',
          class: 'size-col-20',
        }, ,
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
        },
        {
          key: 'mapa',
          label: 'Mapa.',
          class: 'size-col-20',
        },
        {
          key: 'ativo',
          label: 'Ativo',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
      filter: {
        termo: '',
      },
      rows: 0,
      showImportModal: false,
      numeroRegistroInput: '',
      importLoading: false,
      lastImportResponse: null
    }
  },
  computed: {},

  watch: {
    currentPage() {
      this.listar()
    },
    activeTab() {
      this.currentPage = 1
      this.listar()
    },
  },
  mounted() {
    this.listar()
  },
  methods: {
    normalizeProdutoAtivo(produto) {
      const value = produto ? produto.ativo : null
      return value === true || value === 1 || value === '1' || value === 'true'
    },
    processarProdutosListagem(produtos, termo, applyTabFilter = true) {
      this.allProdutos = produtos || []

      const filtered = this.allProdutos.filter((produto) => {
        const nome = produto && produto.nome ? String(produto.nome).toLowerCase() : ''
        const mapa = produto && produto.mapa ? String(produto.mapa).toLowerCase() : ''
        const matchesTerm = !termo || nome.includes(termo) || mapa.includes(termo)

        if (!applyTabFilter) return matchesTerm

        const isActive = this.normalizeProdutoAtivo(produto)
        const matchesTab = this.activeTab === 'ativos' ? isActive : !isActive

        return matchesTab && matchesTerm
      })

      this.rows = filtered.length
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      this.produtos = filtered.slice(start, end)
    },
    async confirmarImport() {
      this.importLoading = true
      this.lastImportResponse = null
      this.lastImportError = null

      try {
        const token = this.$store.state.auth.currentUser.token
        const resposta = await NewProd.register(token, this.numeroRegistroInput)

        this.lastImportResponse = resposta.data || resposta

        const msg = this.lastImportResponse.message || this.lastImportResponse.msg || 'Importação realizada com sucesso!'
        this.$bvToast.toast(
          msg,
          {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        this.showImportModal = false;
        this.listar()

      } catch (error) {
        console.error(error)
        this.lastImportError = error.response.data || { message: 'Erro desconhecido' }

        const msgErr = this.lastImportError.message || this.lastImportError.msg || 'Erro ao realizar importação. Tente novamente.'
        this.$bvToast.toast(
          msgErr,
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.importLoading = false
      }
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    async listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      const termo = this.filter && this.filter.termo
        ? String(this.filter.termo).trim().toLowerCase()
        : ''
      const filterPayload = JSON.stringify({
        ativo: this.activeTab === 'ativos' ? 1 : 0,
      })

      Produto.listar(token, null, null, filterPayload).then(async (resposta) => {
        let produtos = resposta.data.dados || []
        let applyTabFilter = false

        if (!produtos.length && this.activeTab === 'inativos') {
          const fallbackResposta = await Produto.listar(token)
          produtos = fallbackResposta.data.dados || []
          applyTabFilter = true
        }

        this.processarProdutosListagem(produtos, termo, applyTabFilter)
        this.isLoading = this.loading(this.isLoading)
      }).catch(() => {
        this.isLoading = false
      })
    },
    aplicarFiltro() {
      this.currentPage = 1
      this.listar()
    },
    editRegister(empresa) {
      this.produtoEdit = empresa
      this.mostraForm = false
    },
    duplicateRegister(produto) {
      this.produtoEdit = {
        ...produto,
        is_duplicate: true,
        duplicate_source_id: produto.id_produto,
      }
      delete this.produtoEdit.id_produto
      this.mostraForm = false
    },
    cadastra() {
      if (this.produtoEdit) {
        this.produtoEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    Deletar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Produto.deletar(token, this.idProduto)
        .then((resposta) => {
          this.listar()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Produto</div>
            <div class="subTitulo">Visualize, edite e cadastre novos produtos na plataforma.</div>
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Lista</span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row" v-if="mostraForm">
          <div class="col-md-4">
            <b-form-group label="Pesquisar produto" label-for="filter">
              <b-form-input
                id="filter"
                v-model="filter.termo"
                type="text"
                placeholder="Digite o nome do produto ou o número do MAPA"
                @keyup.enter="aplicarFiltro"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group>
              <button class="btn btn-webreceita w-100" @click.prevent="aplicarFiltro">
                Filtrar
              </button>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group>
              <button class="btn btn-webreceita w-100" @click="showImportModal = true">
                Registrar Produto Automaticamente
              </button>
            </b-form-group>
          </div>
        </div>


      </div>
      <div>
        <div v-if="mostraForm">
          <b-tabs content-class="pt-3" pills nav-class="produto-tabs mb-3">
            <b-tab
              :active="activeTab === 'ativos'"
              title="Produtos Ativos"
              @click="activeTab = 'ativos'"
            ></b-tab>
            <b-tab
              :active="activeTab === 'inativos'"
              title="Produtos Inativos"
              @click="activeTab = 'inativos'"
            ></b-tab>
          </b-tabs>

          <b-table striped hover responsive="sm" borderless bordered outlined small :items="produtos"
            :fields="produtoFields" :per-page="perPage">
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button v-b-tooltip.hover title="Editar" type="button" class="btn btn-light"
                  @click="editRegister(row.item)">
                  <i class="uil uil-edit"></i>
                </button>
                <button v-b-tooltip.hover title="Duplicar" type="button" class="btn btn-light"
                  @click="duplicateRegister(row.item)">
                  <i class="uil uil-copy"></i>
                </button>
                <button v-b-tooltip.hover title="Deletar" type="button" class="btn btn-light"
                  @click="modalDelete(row.item.id_produto)">
                  <i class="uil uil-trash-alt"></i>
                </button>
              </div>
            </template>
            <template v-slot:cell(ativo)="row">{{
              row.item.ativo ? 'Sim' : 'Não'
            }}</template>
          </b-table>
          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
        </div>

        <div v-else>
          <formProduto :produto="produtoEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')">Não</b-button>
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-import-agrofit" v-model="showImportModal" title="Adicionar novo produto" title-class="font-18"
      size="md" centered :ok-title="importLoading ? 'Importando...' : 'Importar'"
      :ok-disabled="importLoading || !numeroRegistroInput" @ok.prevent="confirmarImport"
      @hidden="numeroRegistroInput = ''; lastImportResponse = null">
      <b-form-group label="Número de registro (MAPA)"
        description="Ex.: 2923 (será convertido para 02923 automaticamente)">
        <b-form-input v-model="numeroRegistroInput" :disabled="importLoading" autocomplete="off" />
      </b-form-group>

      <b-alert v-if="lastImportResponse && (lastImportResponse.message || lastImportResponse.msg)" show variant="info"
        class="mb-0">
        {{ lastImportResponse.message || lastImportResponse.msg }}
      </b-alert>

      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()" :disabled="importLoading">Cancelar</b-button>
        <b-button variant="primary" @click="confirmarImport()" :disabled="importLoading || !numeroRegistroInput">
          <b-spinner small v-if="importLoading" class="mr-1" /> {{ importLoading ? 'Importando...' : 'Importar' }}
        </b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .produto-tabs {
    .nav-link {
      border-radius: 999px;
      color: #5f6c7b;
      font-weight: 600;
    }

    .nav-link.active {
      background-color: #008e75;
      border-color: #008e75;
      color: #fff;
    }
  }
}
</style>
